import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { throwError } from 'rxjs';
import { catchError, pluck } from 'rxjs/operators';
import { AppConfig } from 'src/app/config-service/app.config';
import { VersionHelper } from 'src/app/utility-packages/versionHelper/version-helper';
import { CookieManagementService } from './cookie-management.service';

interface IUpdateProfileREsModel{
  result: {
    cmd: string,
    code: number,
    message: string,
    dateTime: string,
    debugTimeDiff: string,
    authType: string
  }
}

@Injectable({
  providedIn: 'root'
})
export class UpdateProfileService {

  constructor(
    private http: HttpClient, 
    private translate: TranslateService, 
    private cookieManagementService: CookieManagementService,
    private versionHelper: VersionHelper
  ){}


  updateNameAndSurname(name:string, surname:string, pin:string){
    let body = {additional_info:""};

    let url = AppConfig.settings.apiServer.url + 
      'api/v4.0/account?region=' + AppConfig.settings.city.region + 
      '&authType=' + AppConfig.settings.apiServer.authType + 
      '&version=' + this.versionHelper.getVersion() + 
      '&lang=' + this.cookieManagementService.getlanguage() +
      "&name=" + name +
      "&surname=" + surname +
      "&pin=" + pin 
    ;

    body["additional_info"] = "";

    let accessToken = this.cookieManagementService.getAccessToken();

    if(accessToken == ''){
      return throwError(this.translate.instant('ACCOUNT_ACCOUNT_NOT_FOUND_TOKEN'));
    }
    
    return this.http.put(url, body ,{
      headers: new HttpHeaders({
        "Authorization": "Bearer " + accessToken
      }),
      responseType: 'json'
    }).pipe(
      pluck('result'),
      pluck('message'),
      catchError( error => {
        if(typeof error === 'string'){
          return throwError(error);
        }
        else{
          return throwError(this.translate.instant('DEFAULT_ERROR_MESSAGE'));
        }
      })
    )

  }

}
